import {Link} from "react-router-dom";
import {Translation} from "react-i18next";
import * as FontAwesome from "react-icons/ai";
import React from 'react';
import {UnorderedListOutlined} from "@ant-design/icons";
export const Icon = props => {
    const {iconName} = props;
    const icon = React.createElement(FontAwesome[iconName]);
    return <div className={"anticon anticon-line ant-menu-item-icon"}>{icon}</div>;
};

function getItem(label, key, icon, children, type) {
    return {
        key,
        icon,
        children,
        label,
        type,
    };
}


export const validatePath = (value) => {
    if (value == null) return ""
    if (value === "current") return "/" + window.location.pathname.substring(
        window.location.pathname.lastIndexOf("/") + 1,
        window.location.pathname.length
    )
    if (value.indexOf("/") === -1 || value.indexOf("/") !== 0) return "/" + value
    else {
        if (value[value.length - 1] === "/") return value.substring(0, value.lastIndexOf("/"))
        else return value;
    }
}

function baseUrlLink(subMenu) {
    switch (subMenu) {
        case  "shiftAssignment":
            return "/hrm/timekeeping/time-sheet/shift-assignment" ;
        case  "wageTemplate":
            return "/hrm/timekeeping/wage/template" ;
        case  "shiftWork":
            return "/setting/timekeeping/shift-work" ;
        case  "annualLeave":
            return "/setting/timekeeping/annual-leave" ;
        case  "setupHoliday":
            return "/setting/timekeeping/setup-holiday" ;

        default :
            return;

    }
}

export const getSubMenus = (values, iconDisabled) => {
    return values?.map(subMenu => {
        if (subMenu.enabled === false) return null
        else return subMenu?.childs?.length > 0 ?
            getSubMenu(subMenu, baseUrlLink(subMenu?.name), iconDisabled) :
            getItem(
                subMenu?.key ?
                    <Translation>
                        {(t, {i18n}) =>
                            <span>{t(`layout.${subMenu.name}`)}</span>}
                    </Translation> :
                    <Link to={baseUrlLink(subMenu?.name) + validatePath(subMenu.path)}>
                        <Translation>
                            {(t, {i18n}) =>
                                <span>{t(`layout.${subMenu.name}`)}</span>}
                        </Translation>
                    </Link>,
                subMenu?.key ? subMenu.key : validatePath(subMenu.path),
                !iconDisabled && (subMenu.icon !== "" ?
                        <Icon iconName={subMenu.icon}/> :
                        <UnorderedListOutlined/>
                )
            )
    })
}

const getSubMenu = (value, baseUrlLink, iconDisabled) => {
    if (value.enabled === false) return null
    else
        return getItem(<Translation>
                {(t, {i18n}) =>
                    <span>{t(`layout.${value.name}`)}</span>}
            </Translation>,
            value?.key ? value.key : validatePath(value.path),
            !iconDisabled && (value.icon ?
                    <Icon iconName={value.icon}/> :
                    <UnorderedListOutlined/>
            ),
            getItems(validatePath(value.path), value.childs, baseUrlLink, iconDisabled)
        )
}

const getItems = (parentUrlLink, values, baseUrlLink, iconDisabled) => {
    return values.map(value => {
            if (value.enabled === false) return null
            else return getItem(<Link to={baseUrlLink + parentUrlLink + validatePath(value.path)}>
                    <Translation>
                        {(t, {i18n}) =>
                            <span>{t(`layout.${value.name}`)}</span>}
                    </Translation>
                </Link>,
                value?.path ? parentUrlLink + validatePath(value.path) : value?.key,
                !iconDisabled && (value.icon ?
                        <Icon iconName={value.icon}/> :
                        <Icon iconName={"AiOutlineAntDesign"}/>
                )
            )
        }
    )
}

export const getSubMenuKey = (baseKey, siderData) => {

    for (let i = 0; i < siderData?.length; i++) {
        if (baseKey.indexOf(validatePath(siderData[i].path)) === 0)
            return siderData[i]
    }
}

export const getMenuItemKey = (baseKey, siderData) => {
    for (let i = 0; i < siderData?.length; i++) {
        if (baseKey.indexOf(validatePath(siderData[i].path)) === 0)
            return siderData[i]
    }

}


